import { Record } from 'immutable';
/**
 * This is the standardized format to represent paging information in a reducer.
 * paging information that is needed in any reducer can innitialize their information using this structure
 */
export const PagingState = Record({
  currentPage: 1,
  itemsPerPage: 25,
  sortBy: 'name',
  sortAsc: true,
});

/**
 * This function acts as a helper to a parent reducer.
 * It manages the state of paging information of the parent, specifically currentPage, itemsPerPage, sortBy, and sortAsc information.
 * The result of this function should be used to set the subsection of the parent's state that this is supposed to manage
 * @param {object} state this is the subsection of the parent reducer that deals specifically with paging
 * @param {object} action this is the action that the parent reducer is currently processing
 * @param {object} pagingActions an object expected to be in the format that is produced by the pagingActions function in paging.actions.js
 * @returns a modified version of the given state
 */
export const pagingReducer = (state = new PagingState(), action, pagingActions) => {
  switch (action.type) {
    case pagingActions.page:
      return state.set('currentPage', action.page);
    case pagingActions.perPage:
      return state.set('itemsPerPage', action.perPage);
    case pagingActions.sort:
      return state.set('sortBy', action.sortBy).set('sortAsc', action.sortAsc);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/common/paging/paging.reducer.js